export enum Character {
  LINE_FEED = '\n',
  NBSP = '\u00a0',
  SPACE = ' ',
  WORD_JOINER = '\u2060',
}
